import bg0 from './bg-0.png'
import bg1 from './bg-1.png'
import bg2 from './bg-2.png'
import bg3 from './bg-3.png'
import bg4 from './bg-0.png'
import bg5 from './bg-1.png'
import bg6 from './bg-2.png'
import bg7 from './bg-3.png'
import appLogo from './app-logo.png'
import ios from './apple-download.png'
import iosQrcode from './apple-qrcode.png'
import android from './google-download.png'
import androidQrcode from './google-qrcode.png'
import service from './customer-service.png'
import heyNanaco from './hey-nanaco.png'
import heyNanacoqQrcode from './heynanaco-qrcode.png'
import counselqrcode from './counsel.png'
import counsel from './counsel-qrcode.png'
import market from './market.png'
import mall from './mall.png'
import ride from './ride.png'
import shopping from './shopping.png'
import news from './news.png'
import help from './help.png'
import tool from './tool.png'
import guide from './guide.png'
import ride1 from './ride-bottom-icons.png'
import food2 from './food2.png'
import newsIcon from './newsIcon.png'
import foodIcon from './foods-icon.png'
import paymentIntroduction from './payment-introduction.png'
import paymentIcon0 from './payment-icon0.png'
import paymentIcon1 from './payment-icon1.png'
import paymentIcon2 from './payment-icon2.png'
import paymentIcon3 from './payment-icon3.png'
import paymentIcon4 from './payment-icon4.png'
import paymentimgTitle from './payment-imgTitle.png'
import aboutUs from './about-us.png'
import im from './im.gif'
import appIntroductionIcons from './app-introduction-icons.png'
import appLeftImg from './app-leftImg.png'
import apk from './apk.png'
import functionimage from './function-title.png'
import aboutTitle from './about-title.png'
import aboutImg from './about-image.png'
import aboutBg from './about-bg.png'
import aboutbotimg from './about-bottomimg.png'
import aboutbird from './about-bird.png'
import aboutf from './about-f.png'
import aboutmsg from './about-msg.png'
import foodimg from './food.png'
import agentimg from './agent.png'
import miscimg from './misc.png'
import bottomblue from './function-blue.png'
import paymentcircle from './payment-circle.png'
import appdownloadbg from './appdownload-bg.png'
import penews from './pe-news.png'
import peride from './pe-ride.png'
import peshopping from './pe-shopping.png'
import funcbg from './func-bg.png'
import zhankai from './zhankai.png'
import shouhui from './shouhui.png'
import pepaycir from './pepay-cir.png'
import fucbgs from './fuc-bgs.png'
import fucbg1 from './fuc-bg1.png'
import fucbg2 from './fuc-bg2.png'
import fucmsg from './fuc-msg.png'
import downloadImage_android from './downloadImage.android.png'
let homeBg = null
let downloadImage = null
let roundSparePartsList = null
let peroundSparePartsList = null
let bgIcon = null
let paymentIcon = null
let peAppDownload = null
let peAppDownloadQrcode = null
downloadImage = {
  ios,
  android,
  heyNanaco,
  service,


  apk
}

bgIcon = [
  foodIcon,
  foodIcon,
  foodIcon,
  foodIcon,
  foodIcon
]
homeBg = [
  bg0,
  bg1,
  bg2,
  bg3,
  bg4,
  bg5,
  bg6,
  bg7
]
paymentIcon = [
  paymentIcon0,
  paymentIcon1,
  paymentIcon2,
  paymentIcon3,
  paymentIcon4,
]
roundSparePartsList = {
  market,
  mall,
  ride,
  shopping,
  news,
  guide,
	help,
	tool
}
peroundSparePartsList = {
  agentimg,
  foodimg,
  ride,
  shopping,
  news,
  miscimg
}
peAppDownload = [
  heyNanaco,
  ios,
  android,
  counsel
]
peAppDownloadQrcode = [
  heyNanacoqQrcode,
  iosQrcode,
  androidQrcode,
  counselqrcode
]

export {
  homeBg as homeBg,
  appLogo as appLogo,
  downloadImage as downloadImage,
  roundSparePartsList as roundSparePartsList,
  peroundSparePartsList as peroundSparePartsList,
  bgIcon as bgIcon,
  paymentIntroduction as paymentIntroduction,
  paymentIcon as paymentIcon,
  im as im,
  aboutUs as aboutUs,
  appIntroductionIcons as appIntroductionIcons,
  functionimage as functionimage,
  ride1 as ride1,
  food2 as food2,
  newsIcon as newsIcon,
  paymentimgTitle as paymentimgTitle,
  appLeftImg as appLeftImg,
  aboutTitle as aboutTitle,
  aboutImg as aboutImg,
  aboutBg as aboutBg,
  aboutbotimg as aboutbotimg,
  aboutbird as aboutbird,
  aboutmsg as aboutmsg,
  aboutf as aboutf,
  peAppDownload as peAppDownload,
  peAppDownloadQrcode as peAppDownloadQrcode,
  bottomblue as bottomblue,
  paymentcircle as paymentcircle,
  appdownloadbg as appdownloadbg,
  agentimg as agentimg,
  foodimg as foodimg,
  miscimg as miscimg,
  penews as penews,
  peride as peride,
  peshopping as peshopping,
  funcbg as funcbg,
  zhankai as zhankai,
  shouhui as shouhui,
  pepaycir as pepaycir,
  fucbgs as fucbgs,
  fucbg1 as fucbg1,
  fucbg2 as fucbg2,
  fucmsg as fucmsg,
  downloadImage_android as downloadImage_android
}


// WEBPACK FOOTER //
// ./src/components/images/home/index.js